import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';

import CompetitionsList from './components/CompetitionsList';
import CompetitionDetail from './components/CompetitionDetail';
import CompetitionCreate from './components/CompetitionCreate';

interface ICompetitionsLayout {
  appReady: boolean;
  actions: any;
  organisations: any;
  competitions: any;
  organisationTags: any;
  paymentTags: any;
  paymentRecords: any;
  groups: any;
  match: any;
}
export default class CompetitionsLayout extends React.Component {
  static defaultProps: ICompetitionsLayout = {
    appReady: false,
    actions: undefined,
    organisations: undefined,
    competitions: undefined,
    organisationTags: undefined,
    paymentTags: undefined,
    paymentRecords: undefined,
    groups: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="competitions-app" match={this.props.match}>
        <Route
          exact
          path={['/competitions', '/']}
          render={() => <CompetitionsList {...this.props} />}
        />
        <Route
          path="/competitions/:competitionId"
          render={(): React.ReactNode => <CompetitionDetail {...this.props} />}
        />

        <Route
          exact
          path="/create-competition"
          render={(): React.ReactNode => (
            <CompetitionCreate {...this.props} />
          )}
        />
      </RenderContent>
    );
  }
}
